import React from 'react';
import { PieChart, Pie, Cell } from 'recharts';
import './MultiCircleGraph.scss';
import { drawCircle } from 'helpers/common.js';
import variables from 'style/_vars.module.scss';
import CircleGraph from 'components/CircleGraph/CircleGraph';

export function MultiCircleGraph({ datatestid, num, data }) {
  const width = 300;
  const height = 250;

  return (
    <div
      className="multicircle-container"
      data-testid={datatestid ? `${datatestid}-container` : null}
    >
      <PieChart width={width} height={height}>
        {(num === 0 || num === '--') && (
          <path
            id="arc1"
            fill={variables.gray0}
            d={drawCircle(width / 2, height / 2, 80, 0, 359.99)}
          />
        )}
        {(num === 0 || num === '--') && (
          <path
            id="arc1"
            fill={variables.white}
            d={drawCircle(width / 2, height / 2, 70, 0, 359.99)}
          />
        )}
        <text x="50%" y="50%">
          <tspan
            y="48%"
            x="50%"
            className="multicircle-number"
            alignmentBaseline="middle"
            textAnchor="middle"
          >
            {num}
          </tspan>
          <tspan
            y="58%"
            x="50%"
            className="multicircle-text"
            alignmentBaseline="middle"
            textAnchor="middle"
          >
            Accounts
          </tspan>
        </text>
        {num > 0 && (
          <Pie
            data={data}
            innerRadius={60}
            outerRadius={80}
            paddingAngle={0}
            dataKey="value"
          >
            {data.map((entry, index) => {
              return <Cell key={`cell-${index}`} fill={entry.color} />;
            })}
          </Pie>
        )}
      </PieChart>
    </div>
  );
}

export const DoubleCircle = ({
  defaultTestId,
  limit,
  percent,
  text,
  strokeFill,
  width,
  shortWidth,
}) => {
  return (
    <div className="circlegraph-container">
      {limit && (
        <CircleGraph
          doubleGraph
          datatestid={`${defaultTestId}-current-outer`}
          percent={percent - 100}
          width={width}
          mobileWidth={width}
          strokeWidth={4}
          strokeFill={strokeFill}
          pageType={'reduceCUAction-current-outer'}
        />
      )}
      <CircleGraph
        datatestid={`${defaultTestId}-current`}
        titleText={text}
        subTitleText={''}
        percent={percent}
        width={limit ? shortWidth : width}
        mobileWidth={limit ? shortWidth : width}
        strokeWidth={8}
        strokeFill={strokeFill}
        pageType={'reduceCUAction'}
      />
    </div>
  );
};
